/*
Contact information : id='khazad-25'  
Contact devenir partenaire: id='khazad-26'  
Contact Projet: id='khazad-27'  
Contact rejoindre MobilM : id='khazad-28'  
Inscription Newsletter : id='khazad-29'  
Téléchargement brochure : id='khazad-30'
*/

const vpmContact = document.querySelector('form#vpm-contact')

if (vpmContact) {
    const map = {
        43: 25,
        44: 26,
        41: 27,
        40: 28,
    }
    const submits = vpmContact.querySelectorAll('input[type="submit"]')
    const submit = vpmContact.querySelector('input[type="submit"]:not(.hidden)')
    const defaultId = submit.getAttribute('id')
    const subject = vpmContact.querySelector('select#edit-subject')
    const brochure = vpmContact.querySelector('select#edit-brochure')
    const subjectChange = () => {
        if (brochure.value === '0') {
            const id = map[subject.value]
                ? 'khazad-' + map[subject.value]
                : defaultId
            for (const el of submits) el.classList.add('hidden')
            vpmContact
                .querySelector(`input[id="${id}"]`)
                ?.classList.remove('hidden')
        }
    }
    const brochureChange = () => {
        const id = brochure.value === '0' ? defaultId : 'khazad-30'
        for (const el of submits) el.classList.add('hidden')
        vpmContact
            .querySelector(`input[id="${id}"]`)
            ?.classList.remove('hidden')
        subjectChange()
    }
    subject.addEventListener('input', subjectChange)
    brochure.addEventListener('input', brochureChange)
    brochureChange()
}
